import { useMutation } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'

export interface Variables {
  onboarding_device?: 'mobile' | 'desktop'
}

export type Data = void

export type Options = Omit<UseMutationOptions<Data, Error, Variables>, 'mutationKey' | 'mutationFn'>

export const updateIterableProfile = async (variables: Variables) => {
  const response = await sendToApi(`/users/update_iterable_profile`, {
    method: 'POST',
    body: variables,
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data?.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
}

export const useUpdateIterableProfile = (options?: Options) => {
  return useMutation<Data, Error, Variables>(
    ['updateIterableProfile'],
    async (variables) => {
      return updateIterableProfile(variables)
    },
    options,
  )
}
